import './note.css';
import useDeleteNote from '../../hooks/useDeleteNote';
import useGetPreviewData from '../../hooks/useGetPreviewData';
import Button from '../ui/button/Button';
import UrlPreviewCard from '../ui/urlPreviewCard/UrlPreviewCard';
import { openModal } from '../../components/redux/modalsSlice';
import { linkifyText } from '../../utils/linkifyText';
import { setWasClosedBeforeDrag } from '../redux/taskListSlice';

import { useDispatch, useSelector } from 'react-redux';

export default function Note({ note, linkPreviewId, displayMode }) {
  const { id, title, content, created_at } = note;
  const deleteNote = useDeleteNote(note.folder_id, note.task_list_id);
  const { data: previewData, isLoading } = useGetPreviewData(linkPreviewId);

  const { taskListShown } = useSelector(state => state.taskList);
  const dispatch = useDispatch();

  const handleDragStart = e => {
    e.dataTransfer.setData('text/plain', id);
    e.dataTransfer.effectAllowed = 'move';
    document.body.classList.add('dragging');

    dispatch(setWasClosedBeforeDrag(!taskListShown));
  };

  const handleDragEnd = () => {
    document.body.classList.remove('dragging');
  };

  return (
    <li
      draggable
      className={`tile note ${displayMode === 'list' ? 'row' : ''}`}
      id={id}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onClick={e => {
        if (e.target.closest('[class*="urlPreview"]')) {
          return;
        }
        e.preventDefault();
        dispatch(
          openModal({
            type: 'view',
            noteId: id,
            modalId: crypto.randomUUID(),
          }),
        );
      }}
    >
      <div className="noteHeader">
        <p className="note-title">{title}</p>
        <Button
          className="delete-button"
          onClick={e => {
            e.stopPropagation();
            deleteNote(note);
          }}
        >
          <img
            width="40px"
            className="delete-button-icon"
            src="/icons/trash-icon.svg#trash-icon"
            alt=""
          />
        </Button>
      </div>
      <div className="note-content-wrapper">
        {linkPreviewId && previewData && !isLoading && (
          <UrlPreviewCard borderRounded={true} previewData={previewData} />
        )}
        <p className="note-content">{linkifyText(content)}</p>
      </div>
      <p className="creation-date ">
        {new Date(created_at).toLocaleDateString()}
      </p>
    </li>
  );
}
